import axios from 'axios';


const api = axios.create({
    // baseURL: 'http://localhost:8000/v1/api/management',
    baseURL: 'https://gestao-seller-api-fh5tb5wcfa-uc.a.run.app/v1/api/management',
});

export default api;